import AdminProfileCard from "../../Components/Cards/AdminProfileCard";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const AdminProfile = () => {
    const params = useParams()
    const [admin, setAdmin] = useState({})

    useEffect(() => {
        axios.get(`/admins/${params.id}`)
            .then(response => {
                setAdmin(response.data.admin)
            })
    }, [])

    return (
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
            <div id="kt_content_container" className="container-fluid">
                <div className="d-flex flex-column flex-lg-row">
                    <div className="col-lg-5 offset-lg-3">
                        {admin && (<AdminProfileCard admin={admin} setAdmin={setAdmin} />)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminProfile;